import axios from 'axios';
import { API, auth } from '../pages/organization/finance/shared';

export const getGeneralSettings = () => axios.get(`${API}/report-studio/settings`, auth()).then((r) => r.data);
export const updateGeneralSettings = (settings) => axios.put(`${API}/report-studio/settings`, { settings }, auth()).then((r) => r.data);
export const listReports = () => axios.get(`${API}/report-studio/reports`, auth()).then((r) => r.data);
export const getReportSettings = (key) => axios.get(`${API}/report-studio/reports/${key}/settings`, auth()).then((r) => r.data);
export const updateReportSettings = (key, useCustom, settings) => axios.put(`${API}/report-studio/reports/${key}/settings`, { use_custom: useCustom, settings }, auth()).then((r) => r.data);
export const resetReportSettings = (key) => axios.post(`${API}/report-studio/reports/${key}/reset`, {}, auth()).then((r) => r.data);
export const listTemplates = () => axios.get(`${API}/report-studio/templates`, auth()).then((r) => r.data);
export const createTemplate = (name) => axios.post(`${API}/report-studio/templates`, { name }, auth()).then((r) => r.data);
export const deleteTemplate = (id) => axios.delete(`${API}/report-studio/templates/${id}`, auth()).then((r) => r.data);
export const applyTemplate = (id) => axios.post(`${API}/report-studio/templates/${id}/apply`, {}, auth()).then((r) => r.data);
export const getExportLog = (limit = 50) => axios.get(`${API}/report-studio/export-log`, { ...auth(), params: { limit } }).then((r) => r.data);
export const logExport = (reportKey, format, templateUsed, status, filename) =>
  axios.post(`${API}/report-studio/export-log`, { report_key: reportKey, format, template_used: templateUsed, status, filename }, auth()).catch(() => null);

export const deepMerge = (base, override) => {
  const result = { ...base };
  Object.entries(override || {}).forEach(([k, v]) => {
    result[k] = v && typeof v === 'object' && !Array.isArray(v) && typeof result[k] === 'object' ? deepMerge(result[k], v) : v;
  });
  return result;
};
